<template>
    <div class="deshboard">
        <div class="deshboard-cont">
            <div class="xs-index">
                <div class="xs-nav">
                    <navigator></navigator>
                </div>
            </div>
            <!--<div class="version">
                <span>
                    当前版本：V2.0
                </span>
                <a target="_blank" href="www.baidu.com">
                    上一版本：V1.0
                </a>
            </div>-->
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Navigator from '@/containers/components/navigator';

    import resizeWindow from '@/containers/mixin/resizeWin';
    export default {
        name: 'Dashboard',
        components: {
            Navigator
        },
        mixins: [resizeWindow],
        computed: {
            ...mapState({
                device: state => state.app.device
            })
        }
    }
</script>

<style lang="scss" scoped>
    .deshboard{
        height:100%;
        padding:2% 4% 0;
        .deshboard-cont{
            height:100%;
            background: url("~@/assets/images/index/bg.png") no-repeat left bottom;
            background-size: 100% 100%;
            .version{
                position:absolute;
                bottom:8%;
                right:5%;
                width:2rem;
                line-height:1;
                font-size:0.18rem;
                a,span{
                    margin-bottom:0.3rem;
                    display: block;
                    color:#fff;
                }
                a{
                    text-decoration: underline;
                }
            }
        }
        .xs-index{
            position: relative;
            width:924px;
            height:927px;
            margin:0 auto;
            padding-top:123px;
            background: url("~@/assets/images/index/bg-1.png") no-repeat center 123px;
            background-size: 100% 814px;
            .xs-nav{
                width: 100%;
                height: 9.4%;
                position: absolute;
                bottom: 20.3%;
                left: 0;
                .navigator {
                    width:100%;
                    height:100%;
                    ::v-deep .navigator-title{
                        display: none;
                    }
                    ::v-deep .navigator-main{
                        width:100%;
                    }
                    ::v-deep .main-nav  li span{
                        background:radial-gradient(rgba(152,159,228,1) 0%, rgba(255,255,255,1) 100%);
                        -webkit-background-clip:text;
                        -webkit-text-fill-color:transparent;
                    }
                }
            }
        }

    }
</style>